module.exports = __webpack_public_path__ + "img/aej1n-66wvl.012.f7679f26.png";